/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    style: {
      description: 'Configure `style` variant for `ButtonGroup`',
      type: 'variant',
      values: [ 'contained' ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    },
    width: {
      description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
      type: 'variant',
      values: [ 'responsive', 'equal' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: { gap: 3, space: 3 }
    },
    {
      if: { viewport: [ 'xs' ], width: 'responsive' },
      tokens: { alignItems: 'stretch', direction: 'column' }
    },
    {
      if: { style: 'contained' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 99,
        padding: 8,
        space: 2
      }
    },
    {
      if: {
        style: 'contained',
        viewport: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
      },
      tokens: { borderRadius: 28 }
    }
  ],
  tokens: {
    alignItems: 'center',
    backgroundColor: null,
    borderRadius: 0,
    direction: 'row',
    fieldSpace: 2,
    flexGrow: 0,
    flexShrink: 0,
    gap: 2,
    justifyContent: 'flex-start',
    padding: 0,
    space: 2
  }
}
export default theme
